<template>
  <div v-if="mt5Enabled">
    <div class="select-account">
      <button :disabled="isDisabled" @click="openSelectAccountPop">
        <p :class="{ 'light': isLight }">{{ accountTypeText }}账号 {{ currentAccount ? currentAccount.platformName : '加载中...' }}</p> <em v-if="!isDisabled" :class="{ 'light': isLight }" />
      </button>
      <button v-if="showGoToPlatformTransfer" class="transfer-btn" @click="goToPlatformTransfer">
        <span>转账</span>
      </button>
    </div>
    <div v-if="showSelectAccountPop" class="select-account-pop">
      <div class="popFixed">
        <div class="masking" @click="closeSelectAccountPop" />
        <div class="bottomCon">
          <div class="item">
            <div class="header" :class="{'single': !showGoToPlatformTransfer}"><span class="left" /><span class="center">{{ accountTypeText }}账号</span><span v-if="showGoToPlatformTransfer" class="right" @click="goToPlatformTransfer">转账</span></div>
            <ul>
              <li v-for="account in accTradeInfoList" :key="account.accountGroupId" :class="{'checked': account.platformName == selectedAccount.platformName}">
                <div class="itemCheck" @click="selectAccount(account)">
                  <p>{{ account.platformName }}</p>
                  <em />
                </div>
              </li>
            </ul>
          </div>
          <div class="btnCon">
            <a class="submit" @click="confirmAccount(selectedAccount)">确定</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require('@/assets/css/selectAccount.css')
import { mapState } from 'vuex'
import api from '@/plugins/api'
import { isMT5Enabled } from '@/utils/helper'

export default {
  name: 'SelectAccount',
  props: [
    'onConfirmAccount',
    'onOpen',
    'onClose',
    'accTypeTxt',
    'currentAcc',
    'accList',
    'disableSessionPlatform',
    'disabled',
    'light'
  ],
  computed: {
    ...mapState(['gts2CustomerId', 'platform']),
    showGoToPlatformTransfer: {
      get() {
        return this.currentRoute.path.includes('recharge') && this.accTradeInfoList.length > 1
      }
    }
  },
  watch: {
    currentAcc: function(newVal) {
      this.currentAccount = newVal
      this.selectedAccount = newVal
    },
    accList: function(newVal) {
      this.accTradeInfoList = newVal
    },
    disabled: function(newVal) {
      this.isDisabled = newVal
    },
    light: function(newVal) {
      this.isLight = newVal
    }
  },
  data() {
    return {
      showSelectAccountPop: false,
      currentRoute: this.$route,
      accTradeInfoList: [],
      selectedAccount: this.currentAcc,
      accountTypeText: this.accTypeTxt || '',
      currentAccount: this.currentAcc,
      isDisabled: this.disabled || false,
      mt5Enabled: isMT5Enabled(),
      isLight: this.light || false
    }
  },
  mounted() {
    this.setAccountTypeText()
    if (!this.currentRoute.path.includes('platformTransfer')) {
      this.getAccTradeInfo()
    }
  },
  methods: {
    closeSelectAccountPop() {
      this.showSelectAccountPop = false
      this.selectedAccount = this.currentAccount
      this.$emit('onClose')
    },
    openSelectAccountPop() {
      this.showSelectAccountPop = true
      this.$emit('onOpen')
    },
    setAccountTypeText() {
      if (this.currentRoute.path.includes('recharge')) {
        this.accountTypeText = '存款'
      } else if (this.currentRoute.path.includes('withdrawal')) {
        this.accountTypeText = '取款'
      } else if (this.currentRoute.path.includes('report')) {
        this.accountTypeText = '交易'
      }
    },
    getAccTradeInfo() {
      this.$bus.$emit('loading', false)
      api.getAccTradeInfo(this.gts2CustomerId).then(res => {
        this.$bus.$emit('loading', true)
        if (res.data.code == 200) {
          this.accTradeInfoList = res.data.data.accTradeInfoList
          if (this.disableSessionPlatform) {
            if (this.currentAcc) {
              this.currentAccount = this.accTradeInfoList.find(account => account.platform == this.currentAcc.platform)
            } else {
              this.currentAccount = this.accTradeInfoList[0]
            }
          } else {
            this.currentAccount = this.accTradeInfoList.find(account => account.platform == this.platform)
          }

          this.selectedAccount = this.currentAccount
        }
      })
    },
    selectAccount(account) {
      this.selectedAccount = account
    },
    confirmAccount(account) {
      this.currentAccount = account
      if (!this.disableSessionPlatform) {
        this.$store.dispatch('setPlatform', this.currentAccount.platform)
        this.$store.dispatch('setPlatformName', this.currentAccount.platformName)
        this.$store.dispatch('setGts2AccountId', this.currentAccount.gts2AccountId)
      }
      this.$emit('onConfirmAccount', this.currentAccount)
      this.closeSelectAccountPop()
    },
    goToPlatformTransfer() {
      this.$router.push({ path: '/home/platformTransfer', query: { fromPlatform: this.selectedAccount.platform }})
    }
  }
}
</script>
